
import {defineComponent, PropType} from "vue";
import {CustomerMainCategoryOverviewRestDto} from "@/api/pharma-cpc-product-category-mgmt/models";
import {StatusEnum} from "@/api/enums/status-enum";
import BaseOffcanvasButtonOpen from "@/components/UI/Bootstrap/Offcanvas/BaseOffcanvasButtonOpen.vue";

export default defineComponent({
  name: "CustomerMainCategoryRow",
  components: {BaseOffcanvasButtonOpen},
  emits: ["updateStatus", "editCategory", "deleteCategory"],
  props: {
    category: {
      type: Object as PropType<CustomerMainCategoryOverviewRestDto>,
      required: true,
    },
  },
  computed: {
    StatusEnum() {
      return StatusEnum;
    },
    image(): string {
      if (this.category.image?.image_url) {
        return this.getImage(this.category.image.image_url);
      }
      if (this.category.svg) {
        return this.getSvg(this.category.svg);
      }

      return `<span class="text-muted">${this.$t('noImage')}</span>`;
    }
  },
  methods: {
    getImage(url: string): string {
      return `<img height="40px" src="${url}" alt="" class="category-image">`;
    },
    getSvg(svg: string): string {
      return `<div class="category-svg-container">${svg}</div>`;
    },
  },
});
